<template>
  <div>
    <v-dialog
      v-model="requestACallDialog"
      content-class="request-a-call-dialog-container"
      persistent
      :max-width="isMobile ? '90dvw' : '560px'"
    >
      <v-card class="request-a-call-card">
        <div class="card-inner">
          <v-icon class="card-close" color="black" @click.stop="exitDialog">{{
            icons.mdiClose
          }}</v-icon>
          <div class="dialog-header">Request a call to sign-up</div>
          <v-card-text class="dialog-info">
            <p>
              Let our
              <span>friendly call-center agents walk you through</span> setting
              up your online will <span>in a few easy steps.</span>
            </p>

            <RequestACallDialogForm @success="closeDialog" />
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiClose } from "@mdi/js";
import RequestACallDialogForm from "./RequestACallDialogForm.vue";
export default {
  name: "RequestACallDialog",
  components: {
    RequestACallDialogForm,
  },
  props: {
    showRequestACallDialog: {
      required: true,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      icons: {
        mdiClose: mdiClose,
      },
    };
  },
  computed: {
    requestACallDialog: {
      get() {
        return this.showRequestACallDialog;
      },
      set(value) {
        this.$emit("update:showRequestACallDialog", value);
      },
    },
    isMobile() {
      return this.$isMobileDevice();
    },
  },
  methods: {
    closeDialog(success) {
      this.$emit("success", success);
      if (success) {
        this.requestACallDialog = false;
      }
    },
    exitDialog() {
      this.requestACallDialog = false;
    },
  },
};
</script>

<style lang="scss">
.request-a-call-dialog-container {
  input[name="telephone"] {
    display: none !important;
  }
}
</style>

<style scoped lang="scss">
.request-a-call-dialog-container {
  .request-a-call-card {
    position: relative;
    .card-close {
      position: absolute;
      top: 40px;
      right: 30px;
    }
    .card-inner {
      display: flex;
      flex-direction: column;
      padding: 74px 30px 40px 30px;

      .dialog-header {
        font-size: 22px;
        font-weight: 600;
        line-height: 26.82px;
        margin-bottom: 16px;
      }

      .dialog-info {
        padding: 0;
        p {
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;
        }
        span {
          font-size: 16px;
          font-weight: 600;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
